let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lynDU")).then(() => parcelRequire('8GxI4'));